export const timestampPlusIndex = (index) => {
    return `${Date.now()}-${index}`;
};